import Peer from 'peerjs';
import * as Sentry from '@sentry/browser';
import { backOff } from 'exponential-backoff';

export class PeerFactory {
  static #instance = null;
  #_logger = console;

  static get instance() {
    if (PeerFactory.#instance === null) {
      PeerFactory.#instance = new PeerFactory();
    }

    return PeerFactory.#instance;
  }

  create(id = null) {
    this.#_logger.info('Connecting to signalling server ...');
    const peer = new Peer(id, {
      debug: 0,
      secure: true,
      host: 'a5f7df9.online-server.cloud',
      port: 9000,
      path: '/myapp',
      config: {
        iceServers: [
          { urls: 'stun:stun.l.google.com:19302' },
          {
            urls: 'turn:a5f7df9.online-server.cloud:3478',
            username: 'custit',
            credential: 'DHOPq4ihl+sad4s',
          },
        ],
      },
    });
    peer.on('open', (id) => {
      this.#_logger.info('Connected to signalling server', id);
    });
    peer.on('connection', (connection) => {
      console.log('Label:', connection.label);
      console.log('Metadata:', connection.metadata);
      console.log('Type:', connection.type);
      connection.on('open', (data) => {
        console.log('Connection is open', data);
      });
      connection.on('data', (data) => {
        console.log('Client received data:', data);
      });
      connection.on('close', (data) => {
        console.log('Close', data);
      });
      connection.on('error', (data) => {
        console.log('Error', data);
      });
    });
    peer.on('disconnected', () => {
      this.#_logger.info('Connection to signalling server lost');
      Sentry.captureMessage('Connection to signalling server lost');

      backOff(
        () => {
          this.#_logger.info('Reconnecting to signalling server ...');
          if (!peer.destroyed) {
            peer.reconnect();
          }
        },
        {
          retry: (error, attempts) => {
            this.#_logger.warn(
              'Failed to reconnect! (Attempt ' + attempts + ')',
              error
            );
            Sentry.setContext('Error', error);
            Sentry.captureMessage(
              'Failed to reconnect! (Attempt ' + attempts + ')'
            );

            return !peer.destroyed;
          },
        }
      );
    });
    peer.on('close', () => {
      this.#_logger.info('Connection to signalling server closed');
      Sentry.captureMessage('Connection to signalling server closed');
    });
    peer.on('error', (err) => {
      Sentry.captureException(err);
    });

    return peer;
  }
}

class NewServer {
  #peer = null;

  constructor(id = null) {
    this.#peer = PeerFactory.instance.create(id).on('open', (hostId) => {
      console.log('OPEN', hostId);
    });
  }

  start() {
    if (this.#peer.id === undefined) {
      console.log('Peer id undefined');
      return;
    }

    if (this.#peer.destroyed) {
      console.log('Peer connection destroyed');
      return;
    }

    if (this.#peer.disconnected) {
      console.log('Peer connection disconnected');
      return;
    }

    console.log('start');

    const client = PeerFactory.instance.create().on('open', (clientId) => {
      client.connect(this.#peer.id, {
        metadata: { id: 1234, clientId: clientId },
        reliable: true,
      });
    });
  }
}

export default NewServer;
